import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import s from 'components/shared/theaters/ticketing/ticketCountdown/ticketCountdown.sss';
import { getCopy } from 'utils/copy';


/**
 * Indicates the remaining time of the ticketing session.
 */
export default class TicketCountdown extends Component {

	constructor() {
		super();
		this.state.timeLeft = 0;
	}

	componentWillMount() {
		this.countdown();
		this.timer = setInterval(this.countdown, 1000);
	}

	componentWillReceiveProps(newProps) {
		if (newProps.countdownTo !== this.props.countdownTo) {
			// Restart the timer again
			// Timer has probably been reset
			clearInterval(this.timer);
			this.timer = setInterval(this.countdown, 1000);
		}
	}

	componentWillUnmount() {
		clearInterval(this.timer);
	}

	countdown = () => {
		if (this.props.countdownTo) {
			const timeLeft = this.props.countdownTo - Date.now();
			this.setState({ timeLeft });

			// Ideally, the countdown should be handled in updateTicketing
			// but, as we want the timeout to precisely match the countdown, we can put that here
			if (timeLeft < 1000) {
				// No more timeLeft: go to the timeout page
				Store.emit(actions.GO_TICKETING_TIMEOUT);
				clearInterval(this.timer);
				this.timer = null;
			}
		}
	}

	render(props) {
		const {
			countdownTo // Time (in miliseconds from 1970)
		} = props;

		let seconds = Math.floor(this.state.timeLeft / 1000);
		const minutes = Math.floor(seconds / 60);
		const containerClass = this.state.timeLeft > 1000 && !!countdownTo ? s.countdownVisible : s.countdown;
		seconds = seconds % 60;

		return (
			<div class={containerClass}>
				{getCopy('TICKETING_TIMEOUT_WARNING')}: <span class={s.time}>{('0' + minutes).slice(-2)}:{('0' + seconds).slice(-2)}</span>
			</div>
		);
	}

}
